import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
} from "./RenderUtils";

export class FEINNumberChangeRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <div>
        <Form ref={this.props.formRef}>
          <div>
            {renderEffectiveDate(request, updateRequest)}
            {renderTextBox(
              "newFEINNumber",
              "What is the FEIN#",
              request,
              updateRequest
            )}
            {renderAdditionalComments(updateRequest)}
            {renderFile(request, updateRequest)}
          </div>
        </Form>
      </div>
    );
  }
}
